import styles from "./ListItem.module.scss";
import classNames from "classnames/bind";
import { ChevronRightOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronRightOutlined";

const cx = classNames.bind(styles);

type ListItemProps = {
  label: string | React.ReactElement;
  description?: string | React.ReactElement;
  trailingIcon?: React.ReactElement | null;
  onClick?: () => void;
  className?: string;
  showTopBorder?: boolean;
  showBottomBorder?: boolean;
  leadingIcon?: React.ReactElement;
  isOffer?: boolean;
  hasBackgroundColour?: boolean;
  dataComponent?: string;
  id?: string;
};

export const ListItem = ({
  label,
  description,
  trailingIcon,
  onClick,
  showTopBorder = true,
  showBottomBorder = true,
  className,
  leadingIcon,
  isOffer = false,
  hasBackgroundColour = false,
  dataComponent,
  id,
}: ListItemProps) => {
  const buttonClassNames = cx(styles.listItemButton, className, {
    topBorder: showTopBorder,
    bottomBorder: showBottomBorder,
    isOffer: isOffer,
    hasBackgroundColour: hasBackgroundColour,
    nonInteractive: !onClick,
  });

  const labelClassNames = cx(styles.listItemButton__label, {
    listItemButton__labelString: typeof label === "string",
  });

  return (
    <button
      type="button"
      className={buttonClassNames}
      onClick={onClick}
      data-testid="listItem:button"
      data-component={dataComponent}
      id={id}
    >
      {leadingIcon ? (
        <div
          className={styles.listItemButton__leadingIcon}
          data-testid="listItem:leadingIcon"
        >
          {leadingIcon}
        </div>
      ) : null}
      <div className={styles.listItemButton__textGroup}>
        <div className={labelClassNames} data-testid="listItem:label">
          {label}
        </div>
        {description ? (
          <div
            className={styles.listItemButton__description}
            data-testid="listItem:description"
          >
            {description}
          </div>
        ) : null}
      </div>
      <div
        className={styles.listItemButton__trailingIcon}
        data-testid="listItem:trailingIcon"
      >
        {trailingIcon === undefined ? (
          <ChevronRightOutlined
            size="medium"
            dataTestId="listItem:defaultTrailingIcon"
          />
        ) : (
          trailingIcon
        )}
      </div>
    </button>
  );
};
